// extracted by mini-css-extract-plugin
export default {"actionIcon":"utils_actionIcon__U+vVd","manageFirewallLink":"utils_manageFirewallLink__qR7Xm","lastUpdate":"utils_lastUpdate__C7U6z","actionColumn":"utils_actionColumn__0qtkH"};